import type { ReactNode } from 'react'

// Wrap case-insensitive occurrences of `term` inside `text` with a subtle accent
// highlight — used to mark the matched search term in global-search result rows.
// Returns the text unchanged when there's no term or no text.
export function highlight(text: string | null | undefined, term: string): ReactNode {
  if (!text) return text ?? null
  const q = term.trim()
  if (!q) return text

  // Escape regex metacharacters so a term like "PO-1" matches literally.
  const escaped = q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const parts = text.split(new RegExp(`(${escaped})`, 'ig'))
  return parts.map((part, i) =>
    part.toLowerCase() === q.toLowerCase() ? (
      // biome-ignore lint/suspicious/noArrayIndexKey: positional segments of a static split
      <mark key={i} className="rounded bg-[var(--accent-soft)] px-0.5 font-semibold text-accent">
        {part}
      </mark>
    ) : (
      part
    ),
  )
}
